import React, { Component } from "react";
import { connect } from "react-redux";
import ListItem from "@material-ui/core/ListItem";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import IconButton from "@material-ui/core/IconButton";
import Collapse from "@material-ui/core/Collapse";
import { withStyles } from "@material-ui/core/styles";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import { withTheme } from "@material-ui/core/styles";
import ListItemText from "@material-ui/core/ListItemText";
import DiscussionEntries from "../discussions/DiscussionEntries";
import { withRouter } from "react-router";
import SchoolIcon from "@material-ui/icons/School";
import { Tooltip } from "@material-ui/core";
import Fullscreen from "@material-ui/icons/Fullscreen";
import { taxServiceClient, contentClient } from "../../AxiosClient";
import client from "../../AxiosClient";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Typography from "@material-ui/core/Typography";
import SmsFailedIcon from "@material-ui/icons/SmsFailed";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import { Trans, withTranslation } from "react-i18next";

const styles = (theme) => ({
  listItem: {
    display: "flex",
    paddingRight: "3px",
    paddingLeft: 10,
  },
  contentWrapper: {
    display: "flex",
  },
  alert: {
    color: theme.palette.error.light,
  },
  iconSpan: {
    "& > svg": {
      verticalAlign: "middle",
    },
  },
});

export class KpsListItem extends Component {
  state = {
    expanded: false,
    itemName: "",
  };
  componentDidMount() {
    this.getItemName();
  }
  render() {
    let secondaryInfo = "";
    if (this.props.discussion.type === "DOCUMENT") {
      secondaryInfo = "Document-";
    } else if (this.props.discussion.type === "TOPIC") {
      secondaryInfo = "Topic-";
    } else if (this.props.discussion.type === "TAXONOMY_NODE") {
      secondaryInfo = "Taxonomy-";
    } else {
      secondaryInfo = "Knowledge item-";
    }
    const { classes } = this.props;
    return (
      <div style={{ width: "100%" }}>
        <ListItem
          button
          onClick={this.onClick}
          className={classes.listItem}
          disableGutters
          dense
          selected={this.selected}
        >
          <ListItemIcon>
            {this.props.discussion.discussionRead ? (
              <Tooltip
                title={
                  <Typography>
                    {this.props.t("required_reading_read")}
                  </Typography>
                }
              >
                <ChatBubbleIcon />
              </Tooltip>
            ) : (
              <Tooltip
                title={
                  <Typography>
                    {this.props.t("required_reading_unread")}
                  </Typography>
                }
              >
                <SmsFailedIcon className={classes.alert} />
              </Tooltip>
            )}
          </ListItemIcon>
          <ListItemText
            primary={
              <>
                {this.props.discussion.title}
                {this.props.discussion.expert && (
                  <SchoolIcon style={{ fontSize: 14, paddingLeft: 4 }} />
                )}
              </>
            }
            secondary={secondaryInfo + this.state.itemName}
          />
          <ListItemSecondaryAction>
            <Tooltip title={<Trans i18nKey="global_fullscreen" />}>
              <IconButton onClick={this.onFullscreen}>
                <Fullscreen />
              </IconButton>
            </Tooltip>
            {!this.props.hideExpand && (
              <IconButton onClick={this.toggleExpand}>
                {this.state.expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            )}
          </ListItemSecondaryAction>
        </ListItem>
        {!this.props.hideExpand && (
          <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
            {/* {this.state.expanded ?? */}
            <DiscussionEntries
              openCreateContent={() =>
                this.props.history.push({
                  pathname: `/full/discussion/${
                    this.state.discussion.discussionId
                  }`,
                  state: { createContent: true },
                })
              }
              discussionId={this.props.discussion.discussionId}
              noheader
              // showDiscussions={this.showDiscussions}
              discussion={this.props.discussion}
            />
            {/* } */}
          </Collapse>
        )}
      </div>
    );
  }
  getItemName = () => {
    this.props.discussion.type === "DOCUMENT"
      ? client
          .get(`/document/${this.props.discussion.itemId}`)
          .then((res) => this.setState({ itemName: res.data.userTitle }))
      : this.props.discussion.type === "KNOWLEDGE_ITEM"
        ? contentClient
            .get(`/knowledgeitem/${this.props.discussion.itemId}`)
            .then((res) => this.setState({ itemName: res.data.documentTitle }))
        : this.props.discussion.type === "TOPIC"
          ? taxServiceClient
              .get(`/topic/${this.props.discussion.itemId}`)
              .then((res) => this.setState({ itemName: res.data.topicName }))
          : taxServiceClient
              .get(`/taxonomy/${this.props.discussion.itemId}`)
              .then((res) =>
                this.setState({ itemName: res.data.taxonomyName })
              );
  };
  onClick = (e) => {
    this.props.discussion.type === "DOCUMENT"
      ? this.props.history.push({
          pathname: `/full/document/${this.props.discussion.itemId}`,
          state: { discussionId: this.props.discussion.discussionId },
        })
      : this.props.discussion.type === "KNOWLEDGE_ITEM"
        ? this.props.history.push({
            pathname: `/full/knowledgeitem/${this.props.discussion.itemId}`,
            state: { discussionId: this.props.discussion.discussionId },
          })
        : (this.props.discussion.type === "TAXONOMY_NODE" ||
            this.props.discussion.type === "TOPIC") &&
          this.props.history.push({
            pathname: `/full/taxonomydiscussions/${
              this.props.discussion.type === "TAXONOMY_NODE"
                ? "taxonomy"
                : "topic"
            }/${this.props.discussion.itemId}/discussion/${
              this.props.discussion.discussionId
            }`,
            state: { discussionId: this.props.discussion.discussionId },
          });
  };
  onFullscreen = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.history.push({
      pathname: `/full/discussion/${this.props.discussion.discussionId}`,
      state: { discussion: this.props.discussion },
    });
  };
  toggleExpand = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState((prev) => ({ expanded: !prev.expanded }));
  };
}

const mapStateToProps = (state) => ({
  settings: state.setting.searchSettings,
});

export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(withRouter(withTheme(withTranslation()(KpsListItem)))));
